import React from 'react';

import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

const StyleToolTipIconButton = styled(({ className, ...props }: TooltipProps) => (
	<Tooltip {...props} classes={{ popper: className }} />
))(() => ({
	[`& .${tooltipClasses.tooltip}`]: {
		background: 'rgba(255,255,255, 0.7)',
		borderRadius: '8px',
		padding: '8px',
		minWidth: 'min(250px, fit-content)',
	},
	[`& .${tooltipClasses.arrow}`]: {
		color: 'rgba(255,255,255, 0.7)',
	},
}));

export default StyleToolTipIconButton;
